<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      title="Création d'une agence">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <spinner-round
        :is-loading="loading"
        v-if="loading"></spinner-round>
      <div
        v-else
        class="has-background-white is-border">
        <form>
          <div class="is-padding">
            <div class="field">
              <div class="control columns">
                <div class="column is-6 is-padding-left is-padding-right is-padding-top">
                  <r-label
                    :label="'Nom de l\'agence'"
                    :value="agence.name"></r-label>
                  <v-input
                    id="name"
                    name="name"
                    @input="val => agence.name = val"
                    :model="agence.name"
                    data-vv-as="Nom de l'agence"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val">
                  </v-input>
                </div>
              </div>
            </div>
          </div>
        </form>
        <submit-sticky-buttons
          @submit="submit"
          :loading="submitLoading"
          button-id="agenceCreate"></submit-sticky-buttons>
      </div>
    </page-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AgenceCreate',
  data () {
    return {
      loading: false,
      agence: {
        name: null
      },
      submitLoading: false
    }
  },
  computed: {
    ...mapState(['currentUser'])
  },
  created () {
  },
  methods: {
    /**
      * submit canal creation
      */
    async submit () {
      this.submitLoading = true
      this.agence.promoteur = this.currentUser.pk
      let agence = Object.assign({}, this.agence)
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        try {
          await this.$api.post(this.$resources.AGENCE, agence)
          this.$toasted.global.success('Agence ajouté')
          this.$router.replace({ name: 'AgenceListVue' })
          this.submitLoading = false
        } catch (e) {
          console.log(e)
          this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
          this.submitLoading = false
        }
      }
    }
  }
}
</script>
